import { apiFetch } from "@/lib/api";

export type EarlyPaymentRequestStatus = "requested" | "paid" | "cancelled";

export interface EarlyPaymentRequestRow {
  id: string;
  accounts_payable_invoice_id: string;
  status: EarlyPaymentRequestStatus;
  requested_at: string;
  resolved_at: string | null;
  vendor_invoice_number: string;
  total_amount: string | null;
  currency: string | null;
  purchase_invoice_id: string | null;
  supplier_name: string | null;
  gipi_number: string | null;
  requested_by_display_name: string | null;
  requested_by_email: string | null;
}

export function fetchEarlyPaymentRequests(): Promise<{ rows: EarlyPaymentRequestRow[] }> {
  return apiFetch("/api/accounting/ap/early-payment-requests");
}

export function fetchOpenEarlyPaymentRequest(
  invoiceId: string,
): Promise<{ request: EarlyPaymentRequestRow | null }> {
  return apiFetch(`/api/accounting/ap/invoices/${encodeURIComponent(invoiceId)}/early-payment-request`);
}

export function createEarlyPaymentRequest(
  invoiceId: string,
): Promise<{ request: EarlyPaymentRequestRow; already_open: boolean }> {
  return apiFetch(`/api/accounting/ap/invoices/${encodeURIComponent(invoiceId)}/early-payment-request`, {
    method: "POST",
  });
}

export function updateEarlyPaymentRequestStatus(
  requestId: string,
  status: "paid" | "cancelled",
): Promise<{ request: EarlyPaymentRequestRow }> {
  return apiFetch(`/api/accounting/ap/early-payment-requests/${encodeURIComponent(requestId)}`, {
    method: "PATCH",
    body: { status },
  });
}
